module.exports = __webpack_public_path__ + "img/programme8.0e6a72e1.png";